import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    router.navigate(['/login']);
    return false;
  }

  const user = auth.currentUser;
  // Role is a string ('Admin', 'CrewLead', etc.) — check for Admin
  const roleStr = String(user?.role ?? '');
  const isAdmin = roleStr === 'Admin' || roleStr === '3';
  if (isAdmin) {
    return true;
  }

  // Redirect non-admins to their crew app dashboard
  const tenantId = auth.tenantId;
  router.navigate([`/${tenantId}/app/dashboard`]);
  return false;
};
